import React, { useEffect, useMemo, useState } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import RegularButton from 'components/CustomButtons/Button';
import ModalBase from 'components/Tvendo/Common/ModalBase';
import GridContainer from 'components/Grid/GridContainer';
import Autocomplete from '@material-ui/lab/Autocomplete';
import GridItem from 'components/Grid/GridItem';
import { TextField } from '@material-ui/core';
import { wsGetAll } from 'services/WService';
import useDebounce from 'hooks/useDebounce';
import Table from 'components/Table/Table';
import { useModal } from 'hooks/useModal';
// Iconos
import LibraryAdd from '@material-ui/icons/LibraryAdd';
import Remove from '@material-ui/icons/Remove';
import Add from '@material-ui/icons/Add';
import { wsCreate } from 'services/WService';
import { useNavigate } from 'react-router-dom';

function SelectProductModal(props) {
  const { model, setOpen, materialLists, selectedProduct, setSelectedProduct } = props;
  const [searchString, setSearchString] = useState('');
  const debouncedSearch = useDebounce(searchString, 500);

  const filteredMaterials = useMemo(() => {
    if (debouncedSearch === '') return materialLists;
    return materialLists.filter((item) => {
      return `${item.CardCode}${item.CardName}${item.Code}${item.Name}${item.FatherCode}${item.FatherName}`.includes(
        debouncedSearch,
      );
    });
  }, [materialLists, debouncedSearch]);

  useEffect(() => {
    if (selectedProduct !== undefined) {
      setOpen({ open: false });
    }
  }, [selectedProduct]);

  return (
    <ModalBase model={model} setOpen={setOpen} hideSave fullWidth maxWidth="lg">
      <GridContainer>
        <GridItem xs={4}>
          <TextField
            fullWidth
            label="Buscar..."
            value={searchString}
            onChange={(e) => setSearchString(e.target.value)}
          />
        </GridItem>
        <GridItem xs={8}></GridItem>
        <GridItem xs={12} style={{ maxHeight: '400px', overflow: 'auto' }}>
          <Table
            tableHead={[
              '#',
              'Proveedor',
              'Producto Padre',
              'Cantidad',
              'Producto',
              'Cant. Resultado',
            ]}
            tableData={filteredMaterials.map((item, index) => {
              return [
                <>
                  {index + 1}
                  <RegularButton
                    justIcon
                    round
                    color="primary"
                    onClick={() => setSelectedProduct(item)}
                  >
                    <Add />
                  </RegularButton>
                </>,
                `(${item.CardCode}) ${item.CardName}`,
                `(${item.FatherCode}) ${item.FatherName}`,
                parseInt(item.FatherQuantity),
                `(${item.Code}) ${item.Name}`,
                parseInt(item.Qauntity),
              ];
            })}
          />
        </GridItem>
      </GridContainer>
    </ModalBase>
  );
}

function NewConvertion() {
  const [selectedProduct, setSelectedProduct] = useState();
  const [materialLists, setMaterialList] = useState([]);
  const [zones, setZones] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [convertion, setConvertion] = useState({ Quantity: 1 });
  const [model, setOpen] = useModal();
  const [processing, setProcessing] = useState(false);
  const navigate = useNavigate();

  async function createConvertion() {
    if (selectedProduct === undefined) {
      window.alert('Seleccione un producto');
      return;
    }

    let data = {
      Code: selectedProduct.Code,
      father_quantity: convertion.Quantity,
      base_zone_id: convertion.base_zone_id,
      logi_warehouse_id: convertion.logi_warehouse_id,
    };

    setProcessing(true);
    let res = await wsCreate('logi/convertion', data);
    setProcessing(false);
    if (res.success) {
      window.alert(res.message);
      navigate(`/admin/inventario/operaciones/conversiones/${res.data.id}`);
    } else {
      window.alert(res.message);
    }
  }

  async function listMaterialLists() {
    let res = await wsGetAll('sap/OITT');
    if (res.success) {
      setMaterialList(res.data);
    }
  }

  async function listWarehouses() {
    let res = await wsGetAll('logi/warehouse?warehouse_type=N');
    if (res.success) {
      setWarehouses(res.data);
    }
  }

  async function listZones() {
    let res = await wsGetAll('base/zone');
    if (res.success) {
      setZones(res.data);
    }
  }

  useEffect(() => {
    listZones();
    listWarehouses();
    listMaterialLists();
  }, []);

  return (
    <GridContainer>
      <SelectProductModal
        model={model}
        setOpen={setOpen}
        materialLists={materialLists}
        selectedProduct={selectedProduct}
        setSelectedProduct={setSelectedProduct}
      />
      <GridItem xs={12}>
        <CardContainer title="Nueva orden de conversión">
          <GridContainer>
            {/* Zonal */}
            <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
              <Autocomplete
                options={zones}
                getOptionLabel={(zone) => zone.description}
                renderInput={(params) => (
                  <TextField {...params} label="Zonal" margin="normal" required />
                )}
                value={zones.find((zone) => zone.id === convertion.base_zone_id)}
                onChange={(_, zone) => {
                  if (zone === null)
                    return setConvertion((convertion) => ({
                      ...convertion,
                      base_zone_id: undefined,
                    }));
                  setConvertion((convertion) => ({ ...convertion, base_zone_id: zone.id }));
                }}
              />
            </GridItem>
            {/* Almacén */}
            <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
              <Autocomplete
                options={warehouses}
                getOptionLabel={(warehouse) => warehouse.WhsName}
                renderInput={(params) => (
                  <TextField {...params} label="Almacén" margin="normal" required />
                )}
                value={warehouses.find(
                  (warehouse) => warehouse.id === convertion.logi_warehouse_id,
                )}
                onChange={(_, warehouse) => {
                  if (warehouse === null)
                    return setConvertion((convertion) => ({
                      ...convertion,
                      logi_warehouse_id: undefined,
                    }));
                  return setConvertion((convertion) => ({
                    ...convertion,
                    logi_warehouse_id: warehouse.id,
                  }));
                }}
              />
            </GridItem>
            {/* Valorizado */}
            <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
              <TextField
                label="Valorizado"
                type="number"
                margin="normal"
                fullWidth
                value={convertion.Quantity * (selectedProduct?.Qauntity || 0) || 0}
                InputProps={{ readOnly: true }}
              />
            </GridItem>
          </GridContainer>
        </CardContainer>
      </GridItem>

      {/* Producto padre */}
      <GridItem xs={5}>
        <CardContainer icon={null} title="Lista de materiales">
          {selectedProduct !== undefined && (
            <div
              style={
                {
                  // position: 'absolute',
                  // top: '-55px',
                  // right: '15px',
                }
              }
            >
              <RegularButton
                round
                color="danger"
                size="sm"
                onClick={() => setSelectedProduct(undefined)}
              >
                <Remove />
              </RegularButton>
            </div>
          )}
          {selectedProduct === undefined ? (
            <RegularButton color="success" size="lg" onClick={() => setOpen({ open: true })}>
              <LibraryAdd /> Seleccionar producto
            </RegularButton>
          ) : (
            <GridContainer>
              <GridItem xs={12}>
                ({selectedProduct.FatherCode}) {selectedProduct.FatherName}
              </GridItem>
              <GridItem xs={12}>
                <TextField
                  label="Factor"
                  type="number"
                  value={parseInt(selectedProduct.Qauntity)}
                />
              </GridItem>
            </GridContainer>
          )}
        </CardContainer>
      </GridItem>

      {/* Cantidad / Procesar */}
      <GridItem xs={2}>
        <TextField
          label="Cantidad"
          type="number"
          value={convertion.Quantity || 0}
          onChange={(e) => {
            let value = e.target.value;
            setConvertion((convertion) => ({ ...convertion, Quantity: parseInt(value) }));
          }}
          inputProps={{ min: 1 }}
        />
        <RegularButton
          color="success"
          onClick={createConvertion}
          disabled={
            processing
              ? true
              : selectedProduct === undefined ||
                !convertion.base_zone_id ||
                !convertion.logi_warehouse_id
          }
        >
          Procesar
        </RegularButton>
      </GridItem>

      {/* Producto Destino */}
      <GridItem xs={5}>
        <CardContainer icon={null} title="Producto destino">
          {selectedProduct === undefined ? (
            <span>Seleccione una producto para continuar</span>
          ) : (
            <GridContainer>
              <GridItem xs={12}>
                ({selectedProduct.Code}) {selectedProduct.Name}
              </GridItem>
              <GridItem xs={12}>
                <TextField
                  label="Cantidad Resultado"
                  type="number"
                  value={parseInt(selectedProduct.Qauntity) * convertion.Quantity}
                />
              </GridItem>
            </GridContainer>
          )}
        </CardContainer>
      </GridItem>
    </GridContainer>
  );
}

export default NewConvertion;
